<payee-form-field>
  <input
    payee-input
    placeholder="Ügyvédi iroda neve"
    [formControl]="law_firm_name"
  />
</payee-form-field>
